'use strict';

angular.module('atex.dam').factory("fieldService", function() {
  var fieldService = {};
  fieldService.getField = function(component, row) {
    var field;
    switch(component) {
      case 'desk-assignees':
        var contents = atex.onecms.ObjectUtils.getByPath(row[component], "fields");
        angular.forEach(angular.copy(contents), function (content) {
          var path = atex.onecms.ObjectUtils.getByPath(content, "path");
          var dimension = atex.onecms.ObjectUtils.getByPath(content, "dimension");
          var _fields = atex.onecms.ObjectUtils.getByPath(row.entry, path);
          angular.forEach(angular.copy(_fields), function (_field) {
            if(_field.id === dimension) {
              var entities = _field.entities;
              if(entities.length > 0) {
                field = '';
                for(var i=0; i<entities.length ; i++) {
                  field += entities[i].name;
                }
              }
            }
          });
        });
        break;
      case 'desk-sequential':
       field = row.key;
       field += 1;
       break;
      case 'desk-headline':
       field = atex.onecms.ObjectUtils.getByPath(row.entry, row[component].fields[0].path);
       if(field) {
         field = field.text;
       }
       else {
         field = undefined;
       }
       break;
      case 'desk-status':
      case 'desk-web-status':
      case 'desk-editable-status':
      case 'desk-editable-web-status':
       field = atex.onecms.ObjectUtils.getByPath(row.entry, row[component].field.path);
       if (field) {
        field = field.statusID;
       }
       else {
        field = '';
       }
       break;
     default:
       field = atex.onecms.ObjectUtils.getByPath(row.entry, row[component].fields[0].path);
       if(!field) {
        field = '';
       }
    }
    return field;
  };
  fieldService.getNameField = function(component, row) {
    var obj = {};
    var _field;
    switch(component) {
      case 'desk-status':
      case 'desk-web-status':
      case 'desk-editable-status':
      case 'desk-editable-web-status':
        _field = atex.onecms.ObjectUtils.getByPath(row.entry, row[component].field.path);
        if (_field) {
          obj.field = _field.statusID;
          obj.name = _field.name;
        }
        else {
          obj.field = '';
          obj.name = '';
        }
        break;
      default:
        if(row[component].fields) {
          _field = atex.onecms.ObjectUtils.getByPath(row.entry, row[component].fields[0].path);
        }
        else if(row[component].field) {
          _field = atex.onecms.ObjectUtils.getByPath(row.entry, row[component].field.path);
        }
        if(!_field) {
          _field = '';
        }
        obj.field = _field;
        obj.name = _field;
    }
    return obj;
  };
  fieldService.getDateField = function(component, row) {
    var contents = atex.onecms.ObjectUtils.getByPath(row[component], "fields");
    var date;
    angular.forEach(angular.copy(contents), function (content) {
      var path = atex.onecms.ObjectUtils.getByPath(content, "path");
      var _field = atex.onecms.ObjectUtils.getByPath(row.entry, path);
      content.text = _field;
      date = content.text;
      if (typeof content.text === 'string') {
        date = parseInt(date);
      }
    });
    return date;
  };
  return fieldService;
})
.controller('modalFilterCtrl', function( $scope, $compile, $timeout, fieldService, DamSearchService ) {
  var $elm;
  $scope.showFilterModal = function() {
    $scope.listOfValues = [];
    $scope.nameFieldMap = {};
    $scope.col.grid.appScope.gridOptions.data.forEach( function ( row ) {
      var component = row[$scope.col.colDef.field].componentId;
      var field = fieldService.getNameField(component, row);
      if ( $scope.listOfValues.indexOf( field.name ) === -1 ) {
        $scope.listOfValues.push( field.name );
        $scope.nameFieldMap[field.name] = field.field;
      }
    });
    $scope.listOfValues.sort(function(a, b){
      if( typeof a === 'string' ) {
        return a.localeCompare(b, undefined, {numeric: true, sensitivity: 'base'});
      }
      else {
        return a - b;
      }
    });
    $scope.gridOptions = {
      data: [],
      enableColumnMenus: false,
      onRegisterApi: function( gridApi) {
        $scope.gridApi = gridApi;
        if ( $scope.colFilter && $scope.colFilter.listTerm ){
          $timeout(function() {
            $scope.colFilter.listTerm.forEach( function( term ) {
              var entities = $scope.gridOptions.data.filter( function( row ) {
                return row[$scope.col.colDef.field] === term;
              });
              if( entities.length > 0 ) {
                $scope.gridApi.selection.selectRow( entities[0] );
              }
            });
          });
        }
      }
    };
    $scope.listOfValues.forEach(function( value ) {
      var obj = {};
      obj[$scope.col.colDef.name.split('.').join('')] = value;
      $scope.gridOptions.data.push(obj);
    });
    var html = '<div class="modal" ng-style="{display: \'block\'}"><div class="modal-dialog"><div class="modal-content"><div class="modal-header">Filter</div><div class="modal-body"><div id="grid1" ui-grid="gridOptions" ui-grid-selection class="modalGrid"></div></div><div class="modal-footer"><button id="buttonClose" class="btn btn-primary" ng-click="close()">Filter</button></div></div></div></div>';
    $elm = angular.element(html);
    angular.element(document.body).prepend($elm);
    $compile($elm)($scope);
  };

  $scope.close = function() {
    var values = $scope.gridApi.selection.getSelectedRows();
    $scope.colFilter.listTerm = [];
    var listNames = [];
    values.forEach( function( value ) {
      $scope.colFilter.listTerm.push( $scope.nameFieldMap[value[$scope.col.colDef.name.split('.').join('')]] );
      listNames.push(value[$scope.col.colDef.name.split('.').join('')]);
    });

    $scope.colFilter.term = listNames.join(', ');
    if ($elm) {
      $elm.remove();
    }
  };
})
.directive('modalFilter', ['fieldService', function(fieldService) {
  return {
    template: '<label>{{colFilter.term}}</label><button ng-click="showFilterModal()">...</button>',
    controller: 'modalFilterCtrl'
  };
}])
.controller('dateFilterCtrl', function( $scope, fieldService, UIConfigurationService ) {
  $scope.showDateRange = false;
  UIConfigurationService.profile().then(function (_profile) {
      $scope.colFilter.options = _profile['grid-state'].dateOptions;
      $scope.dateFormat = _profile['grid-state'].dateFormat;
    });
  $scope.colFilter.listTerm = [];
  $scope.onSelect = function() {
    if($scope.selectedOption === 'Custom') {
      $scope.showDateRange = true;
      $scope.isTimestamp = true;
      $scope.id = id();
    }
    else {
      $scope.colFilter.term = $scope.selectedOption;
    }
    $scope.colFilter.listTerm[0] = $scope.colFilter.term;
  };
  function id() {
    return [random(), random()];
  }
  function random() {
    return Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
  }
})
.directive('dateFilter', ['fieldService', 'UIConfigurationService', function(fieldService, UIConfigurationService) {
  return {
    templateUrl: 'date-filter.html',
    controller: 'dateFilterCtrl',
    link: function (scope, element, attrs) {
      scope.open = function (index) {
        var obj = element.find("input[date-picker-id='" + scope.id[index] + "']");
        obj.data("DateTimePicker").show();
      };
      scope.$watch('dates', function (newValue, oldValue) {
        if(newValue) {
          if(scope.dates[0] && scope.dates[1]) {
            scope.colFilter.term = scope.dates[0] + ' TO ' + scope.dates[1];
            scope.colFilter.listTerm[0] = scope.colFilter.term;
          }
        }
      }, true);

      scope.$on("dam:allFiltersCleared", function () {
        scope.selectedOption = null;
        scope.showDateRange = false;
      });
    }
  };
}])
.controller('textFilterCtrl', function( $scope, fieldService ) {
  $scope.options = [ {"label": "__CONTAINS__", "value": "CONTAINS"},
  {"label": "__NOT_CONTAIN__", "value": "NOT_CONTAIN"},
  {"label": "__STARTS_WITH__", "value": "STARTS_WITH"},
  {"label": "__ENDS_WITH__", "value": "ENDS_WITH"},
  {"label": "__EQUALS__", "value": "EQUALS"},
  {"label": "__NOT_EQUAL__", "value": "NOT_EQUAL"}];
  $scope.selectedOption = $scope.options[0].value;
  $scope.colFilter.listTerm = [];
  $scope.onChange = function() {
    if(!$scope.term) {
      $scope.colFilter.term = '*:* ';
      $scope.colFilter.listTerm[0] = $scope.colFilter.term;
      return;
    }
    switch($scope.selectedOption) {
      case 'STARTS_WITH':
        $scope.colFilter.term = '/' + $scope.term + '.*/';
        break;
      case 'CONTAINS':
        $scope.colFilter.term = '/.*' + $scope.term + '.*/';
        break;
      case 'NOT_CONTAIN':
        $scope.colFilter.term = '/.*' + $scope.term + '.*/';
        $scope.colFilter.type = '-';
        break;
      case 'ENDS_WITH':
        $scope.colFilter.term = '/.*' + $scope.term + '/';
        break;
      case 'EQUALS':
        $scope.colFilter.term = '/' + $scope.term + '/';
        break;
      case 'NOT_EQUAL':
        $scope.colFilter.term = '/' + $scope.term + '/';
        $scope.colFilter.type = '-';
        break;
    }
    $scope.colFilter.listTerm[0] = $scope.colFilter.term;
  };
  $scope.$on("dam:allFiltersCleared", function () {
    $scope.selectedOption = $scope.options[0].value;
    $scope.term = null;
  });
})
.directive('textFilter', ['fieldService', function(fieldService) {
  return {
    template: '<form ng-submit="onChange()"><select class="form-control" ng-model="selectedOption" ng-options="option.value as option.label | translate for option in options"></select> <input class="form-control" type="text" ng-model="term"></input></form>',
    controller: 'textFilterCtrl'
  };
}])
.controller('numberFilterCtrl', function( $scope, fieldService ) {
  $scope.options = [ {"label": "__EQUALS__", "value": "equals"},
  {"label": "__NOT_EQUAL__", "value": "does_not_equal"},
  {"label": "__LESS_THAN__", "value": "less_than"},
  {"label": "__GREATER_THAN__", "value": "greater_than"},
  {"label": "__LESS_OR_EQUAL__", "value": "less_than_or_equal"},
  {"label": "__GREATER_OR_EQUAL__", "value": "greater_than_or_equal"},
  {"label": "__BETWEEN__", "value": "between"}];
  $scope.selectedOption = $scope.options[0].value;
  $scope.showNumberRange = false;
  $scope.range = [];
  $scope.colFilter.listTerm = [];
  $scope.onChange = function() {
    if($scope.selectedOption === 'between') {
      $scope.colFilter.type = $scope.selectedOption;
    }
    else {
      $scope.colFilter.term = $scope.term;
      $scope.colFilter.type = $scope.selectedOption;
    }
    $scope.colFilter.listTerm[0] = $scope.colFilter.term;
  };
})
.directive('numberFilter', ['fieldService', function(fieldService) {
  return {
    template: '<form ng-submit="onChange()"><select class="form-control" ng-model="selectedOption" ng-options="option.value as option.label | translate for option in options"></select>' +
    '<input ng-show="!showNumberRange" class="form-control" type="number" ng-model="term"></input></form>' +
    '<div ng-show="showNumberRange"><input placeholder="Start" class="form-control" type="number" ng-model="range[0]"></input><input placeholder="End" class="form-control" type="number" ng-model="range[1]"></input></div>',
    controller: 'numberFilterCtrl',
    link: function (scope, element, attrs) {
      scope.$watch('range', function (newValue, oldValue) {
        if(newValue) {
          if(scope.range[0] && scope.range[1] && (scope.range[1] >= scope.range[0])) {
            var range = [];
            range.push(scope.range[0]);
            range.push(scope.range[1]);
            scope.colFilter.term = range;
            scope.onChange();
          }
        }
      }, true);
      scope.$watch('selectedOption', function (newValue, oldValue) {
        if(newValue === 'between') {
          scope.showNumberRange = true;
        }
        else {
          scope.showNumberRange = false;
        }
      });
      scope.$on("dam:allFiltersCleared", function () {
        scope.selectedOption = scope.options[0].value;
        scope.showNumberRange = false;
        scope.term = null;
      });
    }
  };
}])
.controller('deadlineFilterCtrl', function( $scope, fieldService, UIConfigurationService ) {
  $scope.showDateRange = false;
  UIConfigurationService.profile().then(function (_profile) {
    $scope.colFilter.options = _profile['grid-state'].deadlineOptions;
    $scope.dateFormat = _profile['grid-state'].dateFormat;
  });
  $scope.colFilter.listTerm = [];
  $scope.onSelect = function() {
    if($scope.selectedOption === 'Custom') {
      $scope.showDateRange = true;
      $scope.isTimestamp = true;
      $scope.id = id();
    }
    else {
      $scope.colFilter.term = $scope.selectedOption;
    }
    $scope.colFilter.listTerm[0] = $scope.colFilter.term;
  };
  function id() {
    return [random(), random()];
  }
  function random() {
    return Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
  }
})
.directive('deadlineFilter', ['fieldService', 'UIConfigurationService', function(fieldService, UIConfigurationService) {
  return {
    templateUrl: 'date-filter.html',
    controller: 'deadlineFilterCtrl',
    link: function (scope, element, attrs) {

      scope.open = function (index) {
        var obj = element.find("input[date-picker-id='" + scope.id[index] + "']");
        obj.data("DateTimePicker").show();
      };
      scope.$watch('dates', function (newValue, oldValue) {
        if(newValue) {
          if(scope.dates[0] && scope.dates[1]) {
            var date = [];
            date.push(scope.dates[0]);
            date.push(scope.dates[1]);
            scope.colFilter.term = date;
            scope.colFilter.listTerm[0] = scope.colFilter.term;
          }
        }
      }, true);

      scope.$on("dam:allFiltersCleared", function () {
        scope.selectedOption = null;
        scope.showDateRange = false;
      });
    }
  };
}]);